import { SET_ARCHIVED_EVENT_FS_OBJECT_SORTING } from 'actions/Types';

export default (
  state = {
    sortDirection: 'desc',
    sortBy: 'type'
  },
  action
) => {
  if (action.type === `${SET_ARCHIVED_EVENT_FS_OBJECT_SORTING}`) {
    return action.payload;
  }

  return state;
};
